import React, { useState } from "react";
import { CategoriesList, OpelModal } from "../../organisms";
import { CategoryModal } from "../../mollecules";

function CategoriesTemplate() {
  const [toggleCategoryModal, setToggleCategoryModal] = useState({
    active: false,
    category: null,
  });
  const openCategoryModal = () => {
    setToggleCategoryModal((prevState) => ({
      ...prevState,
      active: true,
    }));
  };
  const closeCategoryModal = () => {
    setToggleCategoryModal((prevState) => ({
      ...prevState,
      active: false,
      category: null,
    }));
  };
  const editCategoryModal = (id) => {
    setToggleCategoryModal((prevState) => ({
      ...prevState,
      active: true,
      category: id,
    }));
  };
  return (
    <div>
      {toggleCategoryModal.active && (
        <CategoryModal
          closeModal={closeCategoryModal}
          toggleModal={toggleCategoryModal}
        />
      )}
      <OpelModal title="Ajouter une catégorie" openModal={openCategoryModal} />
      <CategoriesList editModal={editCategoryModal} />
    </div>
  );
}

export default CategoriesTemplate;
